import { styled } from "../../../stitches.config"

export const Paragraph = styled("p", {
  length: 0,
  color: "$slate11",
  fontSize: "$base",
  fontWeight: 400,
  lineHeight: "$700",
  margin: "$3 0 $6 0",
})
